//HOOKS
import MyToogleButton           from 'resource/hooks/tooglebuttonoptions'
import MyUseInputNumber         from 'resource/hooks/inputTelephone'
import MyUseMultiSelect         from 'resource/hooks/multiselect'

import MyUseTooltip             from 'resource/hooks/tooltip'
import MyUseWindows             from 'resource/hooks/windows'
import MyUseSlider              from 'resource/hooks/slider'
import MyUseSelect              from 'resource/hooks/select'
import UseStrong                from 'resource/hooks/strong'
import MyUseTabs                from 'resource/hooks/tabs'
import {query as MyQuery}       from 'resource/hooks/models'
import {mutation as MyMutation} from 'resource/hooks/models'
import myUseLoder               from 'resource/hooks/useLoader'
import MyUseProgressiveBar      from 'resource/hooks/useProgressiveBar'
import MyUseTimePicker          from 'resource/hooks/timePicker'
import MyUseCheckBox            from 'resource/hooks/checkbox'

    // import MyUseTable            from 'resource/hooks/table'
import MyUseInput               from 'resource/hooks/input'
import MyUseToast               from 'resource/hooks/toast'
import MyUseDropZone            from 'resource/hooks/dropzone'
import MyUseMultiSelectCreate   from 'resource/hooks/toast'
import MyArea                   from 'resource/hooks/textarea'
import MyDatePicker             from 'resource/hooks/datePicker'
//SECURITY
import MyUseSession             from 'resource/security/sessionstorage'
import MyUseLocal               from 'resource/security/localstorage'
import MyUseCookie              from 'resource/security/cookies'
import MyUseJwt                 from 'resource/security/jwt'

//EXPORT
export const    useInput                = MyUseInput
export const    useSelect               = MyUseSelect
export const    useToast                = MyUseToast
export const    useMultiSelect          = MyUseMultiSelect
export const    useDropzone             = MyUseDropZone
export const    useTooltip              = MyUseTooltip
export const    useWindows              = MyUseWindows
export const    UseMultiSelectCreate    = MyUseMultiSelectCreate
export const    useSlider               = MyUseSlider
export const    useInputNumber          = MyUseInputNumber
export const    useToogleButton         = MyToogleButton
export const    useTabs                 = MyUseTabs
export const    useArea                 = MyArea
export default  UseStrong
export const    useDatePicker           = MyDatePicker
export const    useLoader               = myUseLoder
export const    useProgressiveBar       = MyUseProgressiveBar
export const    useTimePicker           = MyUseTimePicker
export const    useCheckBox             = MyUseCheckBox
// export const    useTooltip           = MyUseTable

export const useSession     = MyUseSession
export const useCookie      = MyUseCookie
export const useLocal       = MyUseLocal
export const useJwt         = MyUseJwt
export const mutation       = MyMutation
export const query          = MyQuery
